import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Table from "src/componets/Table";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { ColumnsType } from "antd/es/table";
import { ButtonEdit, ButtonDestroy } from "src/componets/Buttons";
import { setEditId, BannedIpInterface } from "src/store/mine_craft/bannedIpsSlice";
import { destroyBannedIp } from "src/actions/mine_craft/bannedIpsActions";
import { EntityId } from "@reduxjs/toolkit";
import { formattedDate } from "src/helpers/DateHelpers";
import minecraftUrls from "src/configs/mine_craft/minecraftUrls";
import Pagination from "src/componets/Pagination";

import { Space, Tag } from "antd";

interface ListTableInterface {
  className?: string;
  limit: number;
}

const _ListTable = ({ className, limit }: ListTableInterface) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const ids = useAppSelector(state => state.mineCraft.bannedIps.ids);
  const bannedIps = useAppSelector(state => state.mineCraft.bannedIps.entities);
  const count = useAppSelector(state => state.mineCraft.bannedIps.count);
  const data  = ids ? ids.map(id => bannedIps[id]) : [];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: number) {
    dispatch(destroyBannedIp(id)).then(() => navigate(0));
  }

  const columns: ColumnsType<BannedIpInterface> = [
    {
      key: 'ip',
      title: 'IP',
      render: (_, { ip }) => <code>{ip}</code>,
      width: 150
    },

    {
      key: 'user_id',
      title: 'User',
      render: (_, { user_id }) => {
        if (!user_id) return '—';
        return <Link className={`v-link2`} to={minecraftUrls.userPath(user_id)}>#{user_id}</Link>;
      },
      width: 80
    },

    {
      key: 'reason',
      title: 'Reason',
      render: (_, { reason }) => reason || '—',
      ellipsis: true
    },

    {
      key: 'permanent',
      title: 'Type',
      render: (_, { permanent }) => permanent
        ? <Tag color="error">Permanent</Tag>
        : <Tag color="warning">Temporary</Tag>,
      width: 110
    },

    {
      key: 'active',
      title: 'Status',
      render: (_, { active }) => active
        ? <Tag color="success">Active</Tag>
        : <Tag color="default">Expired</Tag>,
      width: 100
    },

    {
      key: 'expires_at',
      title: 'Expires at',
      render: (_, { expires_at }) => {
        if (!expires_at) return '—';
        return <small>{formattedDate(expires_at).dateTime}</small>;
      },
      width: 150
    },

    {
      key: 'created_at',
      title: 'Created at',
      render: (_, { created_at }) => {
        return <small>{formattedDate(created_at).dateTime}</small>;
      },
      width: 150
    },

    {
      key: 'action',
      title: 'Action',
      render: (_, { id }) => {
        return (
          <Space size="middle">
            <ButtonEdit key={'button-edit'} onClick={() => onClickEdit(id)} />
            <ButtonDestroy key={'button-destroy'} onClick={() => onClickDestroy(id)} />
          </Space>
        );
      },
      width: 150
    },
  ];

  return (
    <div className={className}>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />

      <Pagination className='v-mt-10' total={count} size={limit} />
    </div>
  )
}

export default _ListTable;
